<template>
  <div v-loading="staffssalary.salary_statistic.length>=0" :class="mode ? 'home__day' : 'home__night'" class="
      style-scuer
      d-flex
      mt-3
      f-between
      p-3">
    <div :class="mode ? 'performance__topday' : 'performance__topnight'" class="title-new-home-page mb-2 d-flex align-center f-between  ">
     <div> {{$t("Общая заработная плата сотрудников")}}</div>
      <el-date-picker
                  :class="mode ? 'input__day' : 'input__night'"
                    class="w-20"
                    size="medium"
                    v-model="payment_month"
                    type="month"
                    :format="'MMMM yyyy'"
                    :value-format="'yyyy-MM-dd'"
                    :picker-options="paymentMonthsOptions"
                    @change="onMonthChange"
                    :placeholder="$t('message.payment_for')"
                  >
                  </el-date-picker>
    </div>
    <div class="mood__all">

      <div class="mood__bottom" >
        <div class="mood__box" style="background: #90e5f6; border-color: #90e5f6;" :class="mode ? 'mood__boxday' : 'mood__boxnight'" @dblclick="showStaffList('bad', 'getMoodStaffs')">
            <h4 style="margin: 0;">Общая сумма</h4>
          <div class="mood__sticker">
            <h4 :class="mode ? '' : 'text__night2'" style="margin: 0;"> {{ Number(staffssalary.salary_statistic.all_salary).toLocaleString("fi-FI") }} {{ $t('message.amount') }}</h4>
          </div>
        </div>
      </div>
      <div class="mood__bottom">
        <div class="mood__box" style="background: #b9fabe; border-color: #b9fabe;" :class="mode ? 'mood__boxday' : 'mood__boxnight'" @dblclick="showStaffList('bad', 'getMoodStaffs')">
          <div>
            <span>Оплачено</span>
          </div>
          <div class="mood__sticker">
            <h4 :class="mode ? '' : 'text__night2'"  style="margin: 0;">{{ Number(staffssalary.salary_statistic.payd_salary).toLocaleString("fi-FI") }} {{ $t('message.amount') }}</h4>
            
          </div>
        </div>
      </div>
      <div class="mood__bottom">
        <div class="mood__box" style="background:#ffcfac; border-color: #ffcfac;" :class="mode ? 'mood__boxday' : 'mood__boxnight'" @dblclick="showStaffList('bad', 'getMoodStaffs')">
          <div>
            <span>Не оплачено</span>
          </div>
          <div class="mood__sticker">
            <h4 :class="mode ? '' : 'text__night2'">{{ Number(staffssalary.salary_statistic.not_payd_salary).toLocaleString("fi-FI") }} {{ $t('message.amount') }}</h4>
           
          </div>
        </div>
      </div>
    </div>
    <el-drawer
    title="I'm outer Drawer"
    :visible.sync="showUseerModal"
    size="30%"
    :with-header="false"
    ref="show-users"
    @opened="drawerOpened('show-users')"
  >
    <div>
      <show-users-home
        :staff="selected"
        @closeUserModal="closeUserModal"
        :child="child"
        ref="show-users"
      ></show-users-home>
    </div>
  </el-drawer>
  </div>
</template>

<script>
import list from "@/utils/mixins/list";
import showUsersHome from "./show-users-home.vue";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: 'dashboard-mood',
   
  props:{
    staffssalary: {
     type:Object,
    },
    branch_id: {
      type: Boolean,
    },
  },
  props: ['staffssalary', 'branch_id'],
  data: () => ({
    showUseerModal: false,
    selected: null,
    payment_month:null,
    child: {},
  }),
  components:{
    showUsersHome
  },
  computed: {
    ...mapGetters({
      mode: "MODE"
    }),
    paymentMonthsOptions: function () {
      let paidMonths = this.staffPaymentMonths;
      return {
        disabledDate(time) {
          var date = time.getMonth() + 1 + "." + time.getFullYear();
          if (paidMonths.includes(date)) {
            return true;
          }
          return false;
        },
      };
    },
  },
  methods: {
    showStaffList(mood, method='getMoodStaffs') {
      this.showUseerModal = true;
      this.child.branch_id = this.branch_id;
      this.child.method = method;
      this.child.mood = mood;
    },
    closeUserModal(val) {
      this.showUseerModal = val;
    },
    onMonthChange(val) {
      const formatted = this.payment_month;
      this.$emit("month-changed", formatted);
    },
    drawerOpened(ref) {
      if (this.$refs[ref]) {
        if (_.isFunction(this.$refs[ref].opened)) {
          this.$refs[ref].opened(this.child);
        }
      }
    },
   },
   
}
</script>

<style>

</style>
